import axios from "axios";
import env from "@/configuration/env";
import store from "@/stores";

axios.interceptors.request.use((config) => {
  if (config.url.startsWith("/")) {
    // initialization
    config.baseURL = env.api_base_address;
    config.headers.post["Content-Type"] = "application/json";
    config.headers.put["Content-Type"] = "application/json";

    // JWT
    if (store.state.cognito.idToken) config.headers.common["Authorization"] = `Bearer ${store.state.cognito.idToken.jwtToken}`;
  }

  return config;
});

export default {
  init: async () => {},
};
